// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedOctAutoFocusAf_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M2 2H22V22H2V2ZM0 0H24V24H0V0ZM9.99 14.658L10.718 17.038H13L9.458 7H6.868L3.34 17.038H5.622L6.35 14.658H9.99ZM8.758 10.556L9.486 12.88H6.882L7.596 10.556C7.63333 10.4533 7.68467 10.2807 7.75 10.038C7.82467 9.786 7.89933 9.52467 7.974 9.254C8.058 8.974 8.12333 8.74067 8.17 8.554C8.21667 8.74067 8.27733 8.96 8.352 9.212C8.42667 9.464 8.50133 9.71133 8.576 9.954C8.65067 10.1967 8.71133 10.3973 8.758 10.556ZM14.5 16.996H16.586V13.048H19.974V11.312H16.586V8.736H20.226V7H14.5V16.996Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedOctAutoFocusAf is a generated icon component.
 */
let IconMedOctAutoFocusAf = IconMedOctAutoFocusAf_1 = class IconMedOctAutoFocusAf extends IconBaseElement {
    render() {
        return html `${IconMedOctAutoFocusAf_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedOctAutoFocusAf.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedOctAutoFocusAf = IconMedOctAutoFocusAf_1 = __decorate([
    customElement('zui-icon-med-oct-auto-focus-af')
], IconMedOctAutoFocusAf);
export { IconMedOctAutoFocusAf };
